import PropTypes from 'prop-types';

export const CARD_STYLE_SIMPLE = 'simple';
export const CARD_STYLE_NEUTRAL = 'neutral';

export const CARD_STYLES = [CARD_STYLE_SIMPLE, CARD_STYLE_NEUTRAL];

export const STYLE_PROP_TYPE = PropTypes.oneOf(CARD_STYLES);
